<template>

<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <ArenaVehicleTypeList />
    </div>
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaVehicleTypeList from '@/components/settings/arena/vehicle-type/ArenaVehicleTypeList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'Company',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    ArenaVehicleTypeList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addarenavehicletype' })
    }
  }
}
</script>
